import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 5EE154C9-B581-4AB9-A086-38AE96A919E1
 * name clock-time-ten
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-time-ten.svg
 * tags
 * - Date / Time 
 */
export const ClockTimeTenIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 13H11L7 10.7L7.8 9.4L11.1 11.3V7H12.6V13Z" /></>, 'ClockTimeTenIcon');
export default ClockTimeTenIcon